/* eslint-disable no-mixed-operators */

import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';

import TrackF1 from './TrackF1.jsx';
import TrackMotoGP from './TrackMotoGP.jsx';

import { locationsPropType, ticketsPropType } from '../propTypes.js';

function TrackContainer({
  isFetchingticketAvailability = true, locations, selectedLocationId, tickets, type,
}) {
  const map = useRef(null);
  const pageHasBanner = document.querySelector('.c-countdown-banner');
  const bannerOffset = pageHasBanner ? 100 : 0;

  const distance = type === 'formula-one' ? '5.278 KM / 3.280 MILES' : '4.4 KM / 2.76 MILES';
  const title = type === 'formula-one' ? 'Albert Park Grand Prix Circuit' : 'Phillip Island Grand Prix Circuit';

  const [fixedStart, setFixedStart] = useState(0);
  const [fixedEnd, setFixedEnd] = useState(0);

  const calculateFixedStart = () => map.current.getBoundingClientRect().top + window.scrollY - bannerOffset;

  const calculateFixedEnd = () => {
    const wrapper = document.querySelector('.c-track-map__wrapper');
    const rect = wrapper.getBoundingClientRect();

    return rect.top + window.scrollY + wrapper.offsetHeight - bannerOffset;
  };

  const handleScroll = () => {
    const { scrollY } = window;

    if (map.current.offsetHeight >= fixedEnd - fixedStart) return;

    if (scrollY < fixedStart) {
      map.current.classList = 'c-track-map';
      map.current.style.transform = 'translateY(0)';
    }

    if (scrollY >= fixedStart && (map.current.offsetHeight + scrollY <= fixedEnd)) {
      map.current.classList.remove('c-track-map--absolute');
      map.current.style.transform = `translateY(${scrollY - fixedStart}px)`;
    }

    if (map.current.offsetHeight + scrollY > fixedEnd) {
      map.current.classList.add('c-track-map--absolute');
      map.current.style.transform = 'translateY(0)';
    }
  };

  useEffect(() => {
    if (!isFetchingticketAvailability) {
      setFixedStart(calculateFixedStart());
      setFixedEnd(calculateFixedEnd());
    }
  }, [isFetchingticketAvailability, tickets]);

  useEffect(() => {
    if (isFetchingticketAvailability) {
      window.removeEventListener('scroll', handleScroll);
    } else {
      handleScroll();

      window.addEventListener('scroll', handleScroll);
    }

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [fixedStart, fixedEnd, isFetchingticketAvailability]);

  return (
    <div className="c-track-map" ref={map}>
      <h4 className="c-track-map__title">{title}</h4>

      <div className="c-track-map__track">
        {type === 'formula-one'
          ? <TrackF1 locations={locations} selectedLocationId={selectedLocationId} tickets={tickets} />
          : <TrackMotoGP locations={locations} selectedLocationId={selectedLocationId} tickets={tickets} />}
      </div>

      <div className="c-track-map__details">
        <p className="c-track-map__details-title">TRACK DISTANCE</p>
        <p className="c-track-map__details-distance">{distance}</p>
      </div>
    </div>
  );
}

TrackContainer.propTypes = {
  locations: locationsPropType.isRequired,
  tickets: ticketsPropType.isRequired,
  isFetchingticketAvailability: PropTypes.bool,
  selectedLocationId: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
};

export default TrackContainer;
